export default {
    // ----------Title----------
    configuration: '项目参数',
    containerProps: '货柜值数',
    productProps: '商品值数',
    itemProps: '物品值数',
    customerProps: '客户值数',
    customerBranchProps: '客户分行值数',
    deliveryOrderProps: '送货单值数',
    itemReceiveProps: '物品回收值数'
}